// extracted by mini-css-extract-plugin
export default {"sorting-container":"sorting-indicator_sorting-container__MmV0t"};